import { useState } from 'react';
import { IcStar, IcStarOutline } from 'components/common/icons/EmojiIcons';
import styles from './StarRating.module.css';

/* 별 모양은 EmojiIcons 의 IcStar / IcStarOutline 을 그대로 씁니다.
   여기서 path 를 다시 그리면 같은 도형이 두 벌이 되어 한쪽만 바뀝니다. */

/** 읽기용 평점. 앱은 지금까지 숫자만 보여 줬는데, 별 하나를 앞에 두면
 *  숫자가 무엇을 뜻하는지 바로 읽힙니다. */
export const StarRating = ({
    value, size = 14, count, source,
}: {
    value: number;
    size?: number;
    /** 후기 수 */
    count?: number;
    /** 'CREW' 면 우리 후기로 만든 평점 — 외부 평점과 구분해 표시합니다 */
    source?: 'CREW' | 'PROVIDER';
}) => (
    <span className={styles.read}>
        <IcStar size={size} />
        <span className={styles.value}>{value.toFixed(1)}</span>
        {typeof count === 'number' && count > 0 ? (
            <span className={styles.count}>
                {source === 'CREW' ? `DOKOCREW 후기 ${count}` : `(${count})`}
            </span>
        ) : null}
    </span>
);

/** 고르는 별점 — 후기 쓸 때. 손가락으로 누르는 자리라 크게 둡니다. */
export const StarInput = ({
    value, onChange, labels,
}: {
    value: number;
    onChange: (v: number) => void;
    /** 1~5 에 대응하는 말. 숫자만 두면 3점이 좋은 건지 알기 어렵습니다 */
    labels?: string[];
}) => {
    const [hover, setHover] = useState(0);
    const shown = hover || value;
    return (
        <div className={styles.input}>
            <div className={styles.inputStars} role="radiogroup">
                {[1, 2, 3, 4, 5].map(n => (
                    <button
                        key={n}
                        type="button"
                        role="radio"
                        aria-checked={value === n}
                        aria-label={String(n)}
                        className={styles.starBtn}
                        onMouseEnter={() => setHover(n)}
                        onMouseLeave={() => setHover(0)}
                        onClick={() => onChange(n)}
                    >
                        {shown >= n ? <IcStar size={34} /> : <IcStarOutline size={34} />}
                    </button>
                ))}
            </div>
            {labels && shown > 0 ? <span className={styles.hint}>{labels[shown - 1]}</span> : null}
        </div>
    );
};
